<script>
import { getNotes, addNote } from "@/api/subscribers";
import { getGuestNotes, addGuestNote } from "@/api/guests";
import { dateFormat } from "@/utils.js";
export default {
  name: "notes",
  props: ["item"],
  data() {
    return {
      items: [],
      notes: "",
      guest: "guest"
    };
  },
  mounted() {
    console.log("Notes component mounted...");
    console.log(this.item.id);
    this.guest = localStorage.getItem("guest");
    setTimeout(() => this.getNotes(), 1000);
  },
  methods: {
    dateFormat(v) {
      return dateFormat(v);
    },
    async getNotes() {
      if (this.guest == "subscriber") {
        this.items =
          this.item && this.item.id ? await getNotes(this.item.id) : [];
      }
      if (this.guest == "guest") {
        this.items =
          this.item && this.item.id ? await getGuestNotes(this.item.id) : [];
      }
    },
    async addNote() {
      if (!this.notes || this.notes == "") {
        this.$bvToast.toast(`Please type your note`, {
          title: "Notes",
          autoHideDelay: 3000,
          appendToast: false,
          variant: "danger"
        });
        return;
      }
      const payload = JSON.parse(JSON.stringify({ notes: this.notes }));
      let response = null;
      if (this.guest == "subscriber") {
        response = await addNote(this.item.id, payload);
      }
      if (this.guest == "guest") {
        response = await addGuestNote(this.item.id, payload);
      }

      if (response) {
        this.$bvToast.toast(`New note added`, {
          title: "Notes",
          autoHideDelay: 3000,
          appendToast: false,
          variant: "success"
        });
        this.getNotes();
        this.notes = "";
      } else {
        this.$bvToast.toast(`Error in adding your note`, {
          title: "Notes",
          autoHideDelay: 3000,
          appendToast: false,
          variant: "danger"
        });
      }
    }
  }
};
</script>

<template>
  <v-row class="p-1">
    <v-col cols="12">
      <v-card class="mx-auto rounded-lg" outlined>
        <v-row class="pl-4 pr-4">
          <v-col cols="12" sm="4">
            <b-input-group prepend="Note" class="mt-3">
              <b-form-input
                v-model="notes"
                placeholder="Your note"
                required
              ></b-form-input>
              <b-input-group-append>
                <b-button variant="primary" @click="addNote">Add</b-button>
              </b-input-group-append>
            </b-input-group>
          </v-col>
        </v-row>
        <v-list-item>
          <v-list-item-content>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th
                      class="text-left text-dark-75 font-weight-bolder"
                      style="font-size: inherit;"
                    >
                      Note
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in items" :key="index">
                    <td>{{ item.notes }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </v-col>
  </v-row>
</template>
